export default __webpack_public_path__ + "static/media/wafer-bg-right.7574d354.png";